module.exports = __webpack_public_path__ + "img/a123-6.137f8d79.webp";